import React, {
  useState,
  useImperativeHandle,
  forwardRef,
  useEffect,
  useRef,
  useMemo,
} from 'react';
import styled from 'styled-components';
import { FaMapMarkerAlt, FaChevronDown } from 'react-icons/fa';
import { IoClose } from 'react-icons/io5';
import { useSelector } from 'react-redux';

import {
  AddIconPost,
  CloseCircle,
  filter_icon_vector,
  LocationGreen,
  Post,
  Profile,
  ProfileBlack,
  MessageBlack,
  BackArrow,
} from '../../Common/SvgIcon/CommonSvgIcons';
import MyDatePicker from '../DatePicker/DatePicker';
import EngagementFilter from './partials/EngagementFilter';
import FilterDropDown from './partials/FilterDropDown';
import { useDispatch } from 'react-redux';
import {
  reviewsFilterTopic,
  reviewsFilterTopicPreview,
  setFilterPayload,
} from '../../store/redux/slices/topicSlice';
import {
  reviewsFilterChatter,
  reviewsForChatterPreview,
} from '../../store/redux/slices/chatterSlice';
import CalendarDatePicker from './partials/CalendarDatePicker';
import { setMessage } from '../../store/redux/slices/alertMessageSlice';
import { resetFilterPanel } from '../../store/redux/slices/filterPanelSlice';

const Sidebar = styled.div`
  position: fixed;
  top: 0;
  width: 500px;
  height: 100vh;
  overflow-y: auto;
  background: white;
  padding: 10px;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
  transition: right 0.3s ease-in-out;
  z-index: 1000;
  transform: ${({ open, isChatter }) =>
    isChatter
      ? open
        ? `translateX(50px)`
        : `translateX(140%)`
      : open
      ? `translateX(-350px)`
      : `translateX(100%)`};
  transition: transform 0.3s ease-in-out;
  overflow-y: auto;
`;

const Section = styled.div`
  padding-left: 40px;
  margin-bottom: 20px;
`;

const Label = styled.label`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  color: #636363;
  display: flex;
  align-items: center;
  margin-left: 20px;
  gap: 10px;
  margin-bottom: 10px;
`;

const PanelSection = styled.div`
  padding-left: 40px;
  margin-bottom: 16px;
`;

const ButtonRow = styled.div`
  width: 430px;
  display: flex;
  padding-left: 40px;
  justify-content: space-between;
  padding-bottom: 30px;
`;

const Button = styled.button`
  padding: 8px 12px;
  border-radius: 4px;
  border: none;
  cursor: pointer;

  &.clear {
    background: #f3f3f3;
    color: #333;
  }

  &.apply {
    background: #007e55;
    color: white;
  }
`;
const StyledButton = styled.button`
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  border: 1px solid rgba(45, 137, 85, 1);
  color: rgba(45, 137, 85, 1);
  background: white;
  height: 35px;
  padding: 5px 20px;
  border-radius: 10px;

  // border: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  margin-top: 20px;
`;
const GreenDot = styled.span`
  position: absolute;
  top: 16px;
  left: 112px;
  width: 10px;
  height: 10px;
  background-color: green;
  border-radius: 50%;
  border: 2px solid white;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
`;
const Title = styled.div`
  font-family: Inter;
  font-weight: 600;
  color: var(--Body, #2a2929);
  font-size: 24px;
  margin-top: 30px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  border: 2px solid #007e55;
  border-radius: ${(props) =>
    props?.showDropdown == true ? '6px 6px 6px 0px' : '6px'};
  width: 430px;
  height: 50px;
`;
const ContainerRadio = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 150px;
  padding: 10px;
  border: 1px solid #a2a2a2;
  padding-left: 0px;
  padding-right: 0px;
`;
const IconBox = styled.div`
  width: 38px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 20px;
    height: 18px;
  }
`;

const DropdownButton = styled.button`
  background-color: #007e55;
  color: white;
  border: none;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 38px;
  height: 50px;
`;

const SearchInput = styled.input`
  border: none !important;
  outline: none !important;
  padding: 8px;
  font-size: 16px;
  flex: 1;
  margin-top: 0px !important;
  box-shadow: none !important;
  min-width: 100px;
  background: none;
  margin-left: 0px !important;
  height: 35px;
  &:focus {
    outline: none;
    margin-left: 0px;
    box-shadow: none;
  }
`;

const AddButton = styled.button`
  background: none;
  border: none;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const RadioInput = styled.input.attrs({ type: 'radio' })`
  opacity: 0;
  position: absolute;
  pointer-events: none;
`;

const CustomRadio = styled.span`
  height: 15px;
  width: 15px;
  border: 2px solid #2a886b;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  margin-right: 8px;

  ${RadioInput}:checked + &::after {
    content: '';
    position: absolute;
    height: 15px;
    width: 15px;
    background-color: #2a886b;
    border-radius: 50%;
  }

  ${RadioInput}:disabled + & {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TagContainer = styled.div`
  width: 105px;
  height: 23px;
  border-radius: 20px;
  border-width: 1px;
  border: 1px solid var(--Headlines, #2a886b);
  background: #ebf2f3;
  font-family: Inter;
  font-weight: 400;
  font-size: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Tag = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  color: var(--Headlines, #2a886b);
`;

const CloseWrapper = styled.button`
  border: none;
  background: none;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const RadioButtonComponent = ({
  onValueChange,
  selectedOptions,
  selectedOptionValue,
  channel,
}) => {
  const [selectedOption, setSelectedOption] =
    React.useState(selectedOptionValue);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    onValueChange(value); // Emit value to parent
  };

  const options =
    channel === 'twitter' || channel === 'flipkart'
      ? ['Post', 'Profile', 'Location']
      : ['Post', 'Profile'];

  return (
    <ContainerRadio>
      <RadioGroup>
        {options?.map((option, index) => {
          const isDisabledSelected = selectedOptions?.includes(option);
          const isChecked = isDisabledSelected || selectedOption === option;

          return (
            <React.Fragment key={option}>
              <Label>
                <RadioInput
                  type='radio'
                  value={option}
                  checked={isChecked}
                  disabled={isDisabledSelected}
                  onChange={handleChange}
                />
                <CustomRadio />
                <span>{option}</span>
              </Label>
              {index !== options?.length - 1 && <Divider />}
            </React.Fragment>
          );
        })}
      </RadioGroup>
    </ContainerRadio>
  );
};

const ContainerInput = styled.div`
  display: flex;
  align-items: end;
  gap: 10px;
  font-size: 15px;
  font-weight: 600;
  font-family: Inter;

  & input {
    box-shadow: 0px 0px 8px 0px #a2a2a23d;
    border: 1px solid #d9d9d9;
    margin-top: 5px;
    margin-left: -3px;
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    color: #636363;

    padding: 5px 10px;
    border-radius: 5px;
  }
`;
const Divider = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #d9d9d9;
`;
const SvgContainer = styled.button`
  border: none;
  background: none;
  &:hover {
    cursor: pointer;
  }
`;
const BackContainer = styled.button`
  display: flex;
  border: none;
  background: none;
  gap: 10px;
  margin-top: 20px;
`;
const FilterPanelPost = forwardRef((props, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [firstDate, setFirstDate] = useState();
  const [lastDate, setLastDate] = useState();
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [appliedFilters, setApplliedFilters] = useState([]);
  const [searchTerm, setSearchTerm] = useState({
    label: '',
    option: '',
  });
  const [tagArray, setTagArray] = useState([]);
  const [radioButtonControl, setRadioButtonControl] = useState([]);
  const [engagementData, setEngagementData] = useState();
  const [commentError, setCommentError] = useState('');
  const [likeError, setLikeError] = useState('');
  const [viewError, setViewError] = useState('');

  const [genderDemographicData, setGenderDemographicData] = useState();
  const [userTypeData, setUserTypeData] = useState();
  const [sentimentData, setSentimentData] = useState();
  const [emotionsData, setEmotionsData] = useState();
  const [resetTrigger, setResetTrigger] = useState(0);
  const [openPanel, setOpenPanel] = useState(null);
  const [showIcon, setShowIcon] = useState(false);
  const [ratingData, setRatingData] = useState();
  const [showGreenDot, setShowGreenDot] = useState(false);
  const filterPayload = useSelector((state) => state?.filterPanel);

  const dispatch = useDispatch();
  const prevManualResetTrigger = useRef(null);

  useEffect(() => {
    // if (props?.isChatter) {
    if (prevManualResetTrigger.current !== props.manualResetTrigger) {
      if (
        Object.values(filterPayload).every((value) => value === null) === false
      ) {
        setShowGreenDot(true);
      } else {
        setResetTrigger(Date.now());
        setShowGreenDot(false);
      }
      prevManualResetTrigger.current = props.manualResetTrigger;
    }
    // } else {
    //   console.log('in topic');
    //   console.log(prevManualResetTrigger?.current, props?.manualResetTrigger);

    //   if (
    //     prevManualResetTrigger.current !== props.manualResetTrigger &&
    //     prevManualResetTrigger.current !== null
    //   ) {
    //     setResetTrigger(Date.now());
    //     prevManualResetTrigger.current = props.manualResetTrigger;
    //   }
    // }
  }, [props.manualResetTrigger]);

  const handleClear = (modalClick) => {
    setShowGreenDot(false);
    props?.setIsFiltered(false);
    setOpenPanel(null);
    setResetTrigger(Date.now());
    setShowDropdown(false);
    setFirstDate();
    setLastDate();
    setSelectedValues([]);
    setSelectedOption('');
    setSearchTerm({
      label: '',
      option: '',
    });
    setTagArray([]);
    setRadioButtonControl([]);
    setEngagementData();
    setGenderDemographicData();
    setUserTypeData();
    setSentimentData();
    setEmotionsData();
    setShowIcon(false);
    setRatingData();
    setToDateMin(minDate);
    if (!modalClick) {
      props?.setLoading(true);
      const preview_uuid = props?.preview_uuid;
      const job_id = props?.job_id;
      const filterPayload = {};
      dispatch(setFilterPayload({}));
      if (props?.isChatter === true) {
        if (preview_uuid) {
          dispatch(reviewsForChatterPreview({ filterPayload, preview_uuid }))
            .then((res) => {
              props?.setFilteredData(res.payload.data.reviews);
              props?.setLoading(false);
            })
            .catch((error) => {
              console.error('Error:', error); // Handling any errors
              props?.setLoading(false);
            });
        } else {
          dispatch(reviewsFilterChatter({ filterPayload, job_id }))
            .then((res) => {
              props?.setFilteredData(res.payload.data.reviews);
              props?.setLoading(false);
            })
            .catch((error) => {
              console.error('Error:', error); // Handling any errors
              props?.setLoading(false);
            });
        }
      } else {
        dispatch(
          props?.preview_uuid
            ? reviewsFilterTopicPreview({ filterPayload: {}, preview_uuid })
            : reviewsFilterTopic({ filterPayload, job_id })
        )
          .then((res) => {
            props?.setFilteredData(res.payload.data.reviews);
            props?.setLoading(false);
            // setFilter(true)
          })
          .catch((error) => {
            props?.setLoading(false);
            console.error('Error:', error); // Handling any errors
          });
      }
    }
    setIsOpen(false);
  };
  useImperativeHandle(ref, () =>
    Object.values(filterPayload).every((value) => value === null) === true
      ? handleClear
      : undefined
  );
  const handleSearchChange = (e) => {
    setSearchTerm({ label: e.target.value, option: selectedOption });
  };
  const handleValueChange = (value) => {
    setShowIcon(true);
    setSelectedOption(value);
    setSelectedValues([...selectedValues, value]);
    setShowDropdown(false);
  };
  const dateHandler = (e) => {
    const { name, value } = e;

    const formatDate = (isoString) => {
      const date = new Date(isoString); // Create a Date object from the ISO string
      const year = date.getFullYear(); // Get the year
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Get the month (0-based index, hence +1)
      const day = String(date.getDate()).padStart(2, '0'); // Get the day

      return `${year}-${month}-${day}`; // Return the formatted date
    };

    const formattedDate = formatDate(value);

    if (name === 'firstPostDate' && value) {
      // const [year, month, day] = value?.split('-');
      setFirstDate(formattedDate);
      setLastDate();
    } else if (name === 'lastPostDateReview' && value) {
      // const [year, month, day] = value?.split('-');
      setLastDate(formattedDate);
    }
  };
  const handleChange = (data) => {
    setEngagementData(data);
  };
  const removeTag = (tagdata) => {
    const updatedTags = tagArray.filter(
      (tag) => JSON.stringify(tag) !== JSON.stringify(tagdata)
    );
    const array = radioButtonControl;
    const index = array.indexOf(tagdata?.option);
    if (index > -1) {
      array.splice(index, 1);
    }
    setSelectedOption(null);
    setRadioButtonControl(array);
    setSelectedValues(array);
    setTagArray(updatedTags);
    if (updatedTags?.length < 1) {
      setShowIcon(false);
    }
  };
  const handleSelectionChange = (selectedValues) => {
    setGenderDemographicData(selectedValues);
  };
  const handleFilterApply = () => {
    if (typeof props?.setCurrentPage === 'function') {
      props.setCurrentPage(1);
    }

    if (
      engagementData?.filters?.Comments ||
      engagementData?.filters?.Likes ||
      engagementData?.filters?.Views
    ) {
      if (
        engagementData?.filters?.Comments &&
        (engagementData?.sliders?.Comments?.[0] == null ||
          engagementData?.sliders?.Comments?.[1] == null)
      ) {
        setCommentError('Enter a valid Input');
        return;
      }
      if (
        engagementData?.filters?.Likes &&
        (engagementData?.sliders?.Likes?.[0] == null ||
          engagementData?.sliders?.Likes?.[1] == null)
      ) {
        setLikeError('Enter a valid Input');
        return;
      }
      if (
        engagementData?.filters?.Views &&
        (engagementData?.sliders?.Views?.[0] == null ||
          engagementData?.sliders?.Views?.[1] == null)
      ) {
        setViewError('Enter a valid Input');
        return;
      }
    }
    setCommentError('');
    setLikeError('');
    setViewError('');
    const searchData = tagArray?.map((item) => ({
      type: item.option.toLowerCase(),
      value: item.label,
    }));
    const [year, month, day] =
      typeof firstDate === 'string' ? firstDate.split('-') : ['', '', ''];
    const formattedFirstDate = `${day}-${month}-${year}`;

    const [yearLast, monthLast, dayLast] =
      typeof lastDate === 'string' ? lastDate.split('-') : ['', '', ''];
    const formattedLastDate = `${dayLast}-${monthLast}-${yearLast}`;

    const keyMap = {
      Likes: 'likes',
      Replies: 'replies',
      Reposts: 'reposts',
      Views: 'views',
      Comments: 'comments',
      Shares: 'shares',
      Dislikes: 'dislikes',
      Reactions: 'reactions',
    };

    const engagements = {};
    for (const key in engagementData?.filters) {
      if (engagementData?.filters[key]) {
        const sliderValues = engagementData?.sliders[key];

        if (Array.isArray(sliderValues) && sliderValues.length === 2) {
          const [min, max] = sliderValues;
          const mappedKey = keyMap[key];

          engagements[mappedKey] = max > 99999 ? { min } : { min, max };
        } else {
          console.warn(
            `Skipping "${key}" — slider data is invalid:`,
            sliderValues
          );
        }
      }
    }

    const sentimentMap = {
      positive: 1,
      negative: -1,
      neutral: 0,
    };

    const sentiments = Array.isArray(sentimentData)
      ? sentimentData.map((sentiment) => sentimentMap[sentiment])
      : [];

    var filterPayload = {
      search: searchData?.length > 0 ? searchData : null,
      date_from: formattedFirstDate === '--' ? null : formattedFirstDate,
      date_to: formattedLastDate === '--' ? null : formattedLastDate,
      likes: engagements?.likes,
      shares: engagements?.shares,
      views: engagements?.views,
      comments: engagements?.comments,
      reposts: engagements?.reposts,
      replies: engagements?.replies,
      dislikes: engagements?.dislikes,
      reactions: engagements?.reactions,
      gender:
        genderDemographicData?.length > 0
          ? genderDemographicData?.map((item) => item.toLowerCase())
          : null,
      user_type: userTypeData,
      sentiment: sentiments?.length > 0 ? sentiments : null,
      rating: ratingData?.length > 0 ? ratingData : null,
      emotion:
        emotionsData?.length > 0
          ? emotionsData?.map((item) => item.toLowerCase())
          : null,
    };
    filterPayload = Object.fromEntries(
      Object.entries(filterPayload).filter(([_, value]) => value !== null)
    );
    props?.setLoading(true);
    const preview_uuid = props?.preview_uuid;
    const job_id = props?.job_id;
    dispatch(setFilterPayload(filterPayload));
    if (
      Object.values(filterPayload).every((value) => value === undefined) ===
      false
    ) {
      // console.log(filterPayload);
      props?.setIsFiltered(true);
    }
    if (props?.isChatter === true) {
      if (preview_uuid) {
        dispatch(reviewsForChatterPreview({ filterPayload, preview_uuid }))
          .then((res) => {
            props?.setFilteredData(res.payload.data.reviews);
            props?.setLoading(false);
          })
          .catch((error) => {
            console.error('Error:', error); // Handling any errors
            props?.setLoading(false);
          });
      } else {
        dispatch(reviewsFilterChatter({ filterPayload, job_id }))
          .then((res) => {
            props?.setFilteredData(res.payload.data.reviews);
            props?.setLoading(false);
          })
          .catch((error) => {
            console.error('Error:', error); // Handling any errors
            props?.setLoading(false);
          });
      }
    } else {
      dispatch(
        props?.preview_uuid
          ? reviewsFilterTopicPreview({ filterPayload, preview_uuid })
          : reviewsFilterTopic({ filterPayload, job_id })
      )
        .then((res) => {
          props?.setFilteredData(res.payload.data.reviews);
          props?.setLoading(false);
          // setFilter(true)
        })
        .catch((error) => {
          props?.setLoading(false);
          console.error('Error:', error); // Handling any errors
        });
    }
    setOpenPanel();
    setIsOpen(false);
  };

  const minDate = props?.startDate;
  const maxDate = props?.lastDate;
  const [toDateMin, setToDateMin] = useState(minDate);
  useEffect(() => {
    setToDateMin(firstDate);
  }, [firstDate]);

  useEffect(() => {
    if (
      Object.values(filterPayload).every((value) => value === null) === false
    ) {
      const cleanedPayload = Object.fromEntries(
        Object.entries(filterPayload)?.filter(([_, value]) => value !== null)
      );
      for (const key in cleanedPayload) {
        const value = cleanedPayload[key];
        switch (key) {
          case 'search':
            if (value[0]['type'] == 'post') {
              setTagArray([
                {
                  label: value[0]?.value,
                  option: 'Post',
                },
              ]);
              setRadioButtonControl(['Post']);
              break;
            } else if (value[0]['type'] === 'profile') {
              setTagArray([
                {
                  label: value[0]?.value,
                  option: 'Profile',
                },
              ]);
              setRadioButtonControl(['Profile']);
              break;
            } else {
              setTagArray([
                {
                  label: value[0]?.value,
                  option: 'Location',
                },
              ]);
              setRadioButtonControl(['Location']);
              break;
            }

          case 'gender':
            setGenderDemographicData(value);
            break;

          case 'user_type':
            if (value[0] === 'True') setUserTypeData(['verified']);
            else {
              setUserTypeData(['non-verified']);
            }
            break;

          case 'sentiment':
            if (value[0] === -1) {
              setSentimentData(['negative']);
            } else if (value[0] === 1) {
              setSentimentData(['positive']);
            } else {
              setSentimentData(['neutral']);
            }
            break;

          case 'emotion':
            setEmotionsData([value[0]?.toLowerCase()]);
            break;
          case 'rating':
            setRatingData([value[0]]);
            break;
          default:
            break;
        }
      }
      props?.setLoading(true);
      const preview_uuid = props?.preview_uuid;
      const job_id = props?.job_id;
      dispatch(setFilterPayload(cleanedPayload));
      if (props?.isChatter === true) {
        if (preview_uuid) {
          dispatch(
            reviewsForChatterPreview({
              filterPayload: cleanedPayload,
              preview_uuid,
            })
          )
            .then((res) => {
              props?.setFilteredData(res.payload.data.reviews);
              props?.setLoading(false);
              dispatch(resetFilterPanel());
            })
            .catch((error) => {
              console.error('Error:', error); // Handling any errors
              props?.setLoading(false);
            });
        } else {
          dispatch(
            reviewsFilterChatter({ filterPayload: cleanedPayload, job_id })
          )
            .then((res) => {
              props?.setFilteredData(res.payload.data.reviews);
              props?.setLoading(false);
              dispatch(resetFilterPanel());
            })
            .catch((error) => {
              console.error('Error:', error); // Handling any errors
              props?.setLoading(false);
            });
        }
      } else {
        dispatch(
          props?.preview_uuid
            ? reviewsFilterTopicPreview({
                filterPayload: cleanedPayload,
                preview_uuid,
              })
            : reviewsFilterTopic({ filterPayload: cleanedPayload, job_id })
        )
          .then((res) => {
            props?.setFilteredData(res.payload.data.reviews);
            props?.setLoading(false);
            dispatch(resetFilterPanel());

            // setFilter(true)
          })
          .catch((error) => {
            props?.setLoading(false);
            console.error('Error:', error); // Handling any errors
          });
      }

      props?.setIsFiltered(true);

      setOpenPanel();
      setIsOpen(false);
    }
  }, [dispatch, filterPayload]); // include dependencies

  return (
    <>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <StyledButton
          data-testid={'filters'}
          onClick={() => setIsOpen(!isOpen)}
        >
          Filters {filter_icon_vector}
        </StyledButton>

        {(props?.isFilterEd === true || showGreenDot) && <GreenDot />}
      </div>

      <Sidebar
        open={isOpen}
        isChatter={props?.channel === 'flipkart' ? true : false}
      >
        <Section>
          <Title>Filters</Title>
        </Section>
        <Divider />
        <Section>
          <Container showDropdown={showDropdown}>
            {showIcon && (
              <IconBox>
                {selectedOption === 'Location' ? (
                  <FaMapMarkerAlt />
                ) : selectedOption === 'Profile' ? (
                  ProfileBlack
                ) : (
                  MessageBlack
                )}
              </IconBox>
            )}
            <DropdownButton onClick={() => setShowDropdown(!showDropdown)}>
              <FaChevronDown />
            </DropdownButton>
            <SearchInput
              onFocus={() => setShowDropdown(false)}
              placeholder='Search'
              value={searchTerm?.label}
              onChange={handleSearchChange}
              disabled={selectedValues?.length < 1}
            />
            <AddButton
              data-testid='filter-button'
              disabled={tagArray?.length > 3}
              onClick={() => {
                if (
                  searchTerm?.label?.length > 0 &&
                  searchTerm?.label?.length < 30
                ) {
                  var temp = tagArray;
                  temp?.push({
                    label: searchTerm?.label,
                    option: selectedOption,
                  });
                  setTagArray(temp);
                  setShowDropdown(false);
                  setSearchTerm({
                    label: '',
                    option: '',
                  });
                  setRadioButtonControl([
                    ...radioButtonControl,
                    selectedOption,
                  ]);
                  setShowIcon(false);
                } else {
                  dispatch(
                    setMessage({
                      message: 'Please provide a valid input!',
                      timer: 'off',
                      type: 'rejected',
                    })
                  );
                }
              }}
            >
              {AddIconPost}
            </AddButton>
          </Container>
          {showDropdown && (
            <div>
              <RadioButtonComponent
                channel={props?.channel}
                onValueChange={handleValueChange}
                selectedOptions={radioButtonControl}
                selectedOptionValue={selectedOption}
              />
            </div>
          )}
          <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
            {tagArray?.length > 0 &&
              tagArray?.map((data, index) => {
                return (
                  <>
                    <TagContainer key={index}>
                      <div
                        style={{
                          marginLeft: '5px',
                          display: 'flex',
                          gap: '5px',
                          alignItems: 'center',
                        }}
                      >
                        {data?.option === 'Post'
                          ? Post
                          : data?.option === 'Profile'
                          ? Profile
                          : LocationGreen}
                        <Tag>
                          {data?.label?.slice(0, 5)}
                          {data?.label?.length > 5 && '...'}
                        </Tag>
                      </div>

                      <CloseWrapper
                        onClick={() => {
                          removeTag(data);
                        }}
                      >
                        {CloseCircle}
                      </CloseWrapper>
                    </TagContainer>
                  </>
                );
              })}
          </div>
        </Section>

        <Section style={{ display: 'flex', gap: '40px' }}>
          <ContainerInput>
            <div>
              <div
                style={{
                  color: '#2a2929',
                }}
              >
                From Date:
              </div>
              <CalendarDatePicker
                width='100px'
                name='firstPostDate'
                value={firstDate ? firstDate : ''}
                dateHandler={dateHandler}
                format={'dd-MM-yyyy'}
                showIcon={true}
                placeholder='DD-MM-YYYY'
                min={minDate ? minDate : ''}
                max={maxDate ? maxDate : ''}
              />
            </div>
          </ContainerInput>
          <ContainerInput>
            <div>
              <div
                style={{
                  color: '#2a2929',
                }}
              >
                To Date:
              </div>
              <CalendarDatePicker
                width='100px'
                name='lastPostDateReview'
                value={lastDate ? lastDate : ''}
                dateHandler={dateHandler}
                format={'dd-MM-yyyy'}
                showIcon={true}
                placeholder='DD-MM-YYYY'
                min={toDateMin ? toDateMin : minDate}
                max={maxDate ? maxDate : ''}
              />
            </div>
          </ContainerInput>
          <ContainerInput
            title='Click here to clear filter'
            style={{ alignItems: 'start', paddingRight: '20px' }}
          >
            <SvgContainer
              style={{
                background: 'none',
                border: 'none',
              }}
              onClick={() => {
                setFirstDate();
                setLastDate();
              }}
            >
              <IoClose />
            </SvgContainer>
          </ContainerInput>
        </Section>
        <Divider />

        <PanelSection>
          <EngagementFilter
            title='Engagement'
            isOpen={openPanel === 'engagement'}
            onToggle={() =>
              setOpenPanel(openPanel === 'engagement' ? null : 'engagement')
            }
            resetTrigger={resetTrigger}
            filterLabels={
              props?.channel === 'twitter'
                ? ['Likes', 'Replies', 'Reposts', 'Views']
                : props?.channel === 'facebook'
                ? ['Likes', 'Comments', 'Shares']
                : props?.channel === 'instagram'
                ? ['Likes', 'Comments', 'Views']
                : props?.channel === 'flipkart'
                ? ['Likes', 'Dislikes']
                : props?.channel === 'youtube'
                ? ['Likes', 'Comments', 'Views']
                : []
            }
            onChange={handleChange}
            likeError={likeError}
            viewError={viewError}
            commentError={commentError}
            setViewError={setViewError}
            setCommentError={setCommentError}
            setLikeError={setLikeError}
          />
        </PanelSection>
        <Divider />

        {props?.channel === 'flipkart' && (
          <>
            <PanelSection>
              <FilterDropDown
                title='Rating'
                options={['1', '2', '3', '4', '5']}
                onChange={(data) => {
                  setRatingData(data);
                }}
                resetTrigger={resetTrigger}
                isOpen={openPanel === 'rating'}
                onToggle={() =>
                  setOpenPanel(openPanel === 'rating' ? null : 'rating')
                }
                selectedOptions={
                  Object.values(filterPayload).every(
                    (value) => value === null
                  ) === false
                    ? ratingData
                    : undefined
                }
              />
            </PanelSection>
            <Divider />
          </>
        )}
        <PanelSection>
          <FilterDropDown
            title='Gender Demographics'
            options={['Male', 'Female', 'Unknown']}
            onChange={handleSelectionChange}
            resetTrigger={resetTrigger}
            selectedOptions={
              Object.values(filterPayload).every((value) => value === null) ===
              false
                ? genderDemographicData
                : undefined
            }
            isOpen={openPanel === 'gender'}
            onToggle={() =>
              setOpenPanel(openPanel === 'gender' ? null : 'gender')
            }
          />
        </PanelSection>
        <Divider />

        {props?.channel === 'twitter' && (
          <>
            <PanelSection>
              <FilterDropDown
                title='User Type'
                options={['Verified', 'Non-Verified']}
                onChange={(data) => {
                  if (data?.length > 0) {
                    const result = data?.map((status) =>
                      status === 'verified' ? 'True' : 'False'
                    );
                    setUserTypeData(result);
                  } else {
                    setUserTypeData(null);
                  }
                }}
                resetTrigger={resetTrigger}
                selectedOptions={
                  Object.values(filterPayload).every(
                    (value) => value === null
                  ) === false
                    ? userTypeData
                    : undefined
                }
                isOpen={openPanel === 'User Type'}
                onToggle={() =>
                  setOpenPanel(openPanel === 'User Type' ? null : 'User Type')
                }
              />
            </PanelSection>
            <Divider />
          </>
        )}
        <PanelSection>
          <FilterDropDown
            title='Sentiments'
            options={['Positive', 'Negative', 'Neutral']}
            onChange={(data) => {
              setSentimentData(data);
            }}
            resetTrigger={resetTrigger}
            selectedOptions={
              Object.values(filterPayload).every((value) => value === null) ===
              false
                ? sentimentData
                : undefined
            }
            isOpen={openPanel === 'Sentiment'}
            onToggle={() =>
              setOpenPanel(openPanel === 'Sentiment' ? null : 'Sentiment')
            }
          />
        </PanelSection>
        <Divider />

        <PanelSection>
          <FilterDropDown
            resetTrigger={resetTrigger}
            title='Emotions'
            options={[
              'Joy',
              'Surprise',
              'Neutral',
              'Sadness',
              'Disgust',
              'Anger',
              'Fear',
            ]}
            onChange={(data) => {
              setEmotionsData(data);
            }}
            selectedOptions={
              Object.values(filterPayload).every((value) => value === null) ===
              false
                ? emotionsData
                : undefined
            }
            isOpen={openPanel === 'Emotions'}
            onToggle={() =>
              setOpenPanel(openPanel === 'Emotions' ? null : 'Emotions')
            }
          />
        </PanelSection>
        <Divider />

        <ButtonRow>
          <Button
            className='clear'
            data-testid='clear-button'
            onClick={() => handleClear(false)}
          >
            Clear All
          </Button>
          <Button
            className='apply'
            data-testid='apply-button'
            onClick={() => {
              handleFilterApply(false);
            }}
          >
            Apply
          </Button>
        </ButtonRow>
      </Sidebar>
      {isOpen && (
        <>
          <Overlay
            onClick={() => {
              setIsOpen(false);
              setShowDropdown(false);
              // handleClear(true);
            }}
          />
        </>
      )}
    </>
  );
});

export default FilterPanelPost;
